import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {filter} from 'lodash';
import {bindActionCreators} from 'redux';
import {get} from '../../redux/modules/general';
import {SocialButtons} from '../index';

class Footer extends PureComponent {

  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const {general: {values: {copyright = {body: ''}, contacts}, isFetching}} = this.props;
    const sContacts = isFetching ? [] : filter(contacts, {type: 'social'});
    return (
      <footer className="navbar-fixed-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <span className="copyright">Copyright &copy; <a href="#" dangerouslySetInnerHTML={{__html: copyright.body}}/></span>
            </div>
            <div className="col-md-4">
            </div>
            <div className="col-md-4">
              <SocialButtons follow={sContacts}/>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default connect(
  (state) => {
    return {
      general: state.general
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js